// Import Packages
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

// Import Pages
import { TextInput } from '../../../FlowConfigurationInputs/TextInput/NewTextInput';
import VariablePicker from '../../../FlowConfigurationInputs/VariablePicker/VariablePicker';
import FieldLabel from '../../../FlowConfigurationInputs/FieldLabel/FieldLabel';
import { RadioPicker, RadioOption } from '../../../FlowConfigurationInputs/RadioPicker/RadioPicker';
import { Checkboxes } from '../../../FlowConfigurationInputs';

// Import Recoil
import { initialActions, saveAvailable, changedFields, alertState } from "../../../../recoil-store/recoil-state";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";

// Import Material UI
import { Button, Dialog, DialogTitle, ButtonGroup, DialogContentText, DialogContent } from "@material-ui/core/";

// Import Helpers
import { CheckIfFlowUpdated } from '../../../../helpers/helper';

/**
 * @Description this page Datatable Library's Sort Row Action's configuration form
 * @Param       action - object 
 * @Param       variables - object variable list
 * @Param       setOpenVariable - open variable function that allows us to open
 * @Param       variableRenbder - variable render 
 * @Returns     div element
 * @Author      Abdullah Onur Yeşil
 */
export default function SortRows({ action, variables, setOpenVariable, variableRender, visible }) {
    const [sortType, setSortType] = useState('ascending');
    const [columnSelector, setColumnSelector] = useState('name');

    const { t } = useTranslation();

    const initialActionsData = useRecoilValue(initialActions);
    const setSaveAvailable = useSetRecoilState(saveAvailable);
    const [changedFieldsState, setChangeFields] = useRecoilState(changedFields);

    const baseLabel = 'CONTENT.CONFIGURATION-FORM.DATA-TABLE.';
    const label = baseLabel + 'SORT-ROWS.';
    useEffect(() => {
        if (!action.fields.sortType) {
            action.fields.sortType = { value: 'ascending' }
        }

        if (!action.fields.columnSelector) {
            action.fields.columnSelector = { value: 'name' }
        }

        if (!action.fields.sortWithHeader) {
            action.fields.sortWithHeader = { value: true }
        }
        setColumnSelector(action.fields.columnSelector.value);
        setSortType(action.fields.sortType.value);
    }, [action.id])


    const handleClick = (e) => {
        let value = e.target.value;

        const field = initialActionsData[action.id]?.fields["sortType"];
        const oldValue = !field ? undefined : field.value;
        CheckIfFlowUpdated("sortType", action, oldValue, value, setSaveAvailable, setChangeFields, changedFieldsState);

        action.fields.sortType = { value };
        setSortType(value);
    };

    const changeColumnSelector = (selector) => {

        const field = initialActionsData[action.id]?.fields["columnSelector"];
        const oldValue = !field ? undefined : field.value;
        CheckIfFlowUpdated("columnSelector", action, oldValue, selector, setSaveAvailable, setChangeFields, changedFieldsState);

        action.fields.columnSelector.value = selector;
        setColumnSelector(selector);
    };

    return (
        <div>
            <div className={`conf-field-container ${visible ? "display-none" : ""}`}>
                <FieldLabel name={t(baseLabel + 'SOURCE-DATA')} is_required />
                <VariablePicker action={action} inputName="sourceData" variables={variables}
                    setOpenVariable={setOpenVariable} filter="data table" isRequired hideRequired />
                <small className="conf-field-desc"><em>{t('CONTENT.CONFIGURATION-FORM.VARIABLE-HELPER', { type: 'data table' })}</em></small>
            </div>
            <div className="conf-field-container condition-tabs">
                <button className={sortType === 'ascending' ? 'condition-active' : ''}
                    value="ascending" onClick={handleClick}>
                    {t(label + 'ASCENDING')}
                </button>
                <button className={sortType === 'descending' ? 'condition-active' : ''}
                    value="descending" onClick={handleClick}>
                    {t(label + 'DESCENDING')}
                </button>
            </div>
            <div className="conf-field-container">
                <FieldLabel name={t(label + 'COLUMN-INFO')} />
            </div>
            <ButtonGroup size="medium" aria-label="small outlined button group">
                <Button
                    className={columnSelector === 'index' ? "btn-gray" : ""}
                    id="button-group"
                    onClick={(e) => changeColumnSelector('index')}
                    variant="outlined"
                >
                    {t(baseLabel + "COLUMN-INDEX")}
                </Button>
                <Button
                    className={columnSelector === 'name' ? "btn-gray" : ""}
                    id="button-group"
                    onClick={(e) => changeColumnSelector('name')}
                    variant="outlined"
                >
                    {t(baseLabel + "COLUMN-NAME")}
                </Button>
            </ButtonGroup>
            <div className="conf-field-container m-t-20">
                <FieldLabel name={t(baseLabel + 'COLUMN')} is_required />
                <TextInput
                    action={action}
                    inputName={"column"}
                    variables={variables}
                    setOpenVariable={setOpenVariable}
                    isRequired
                    hideRequired
                />
                <small className="conf-field-desc"><em>{t(baseLabel + 'COLUMN-INFO')}</em></small>
            </div>

            {/* <div className="conf-field-container">
                <RadioPicker value={columnTab} onChange={handleChange}>
                    <RadioOption value="index" >
                        <FieldLabel name={t(baseLabel + 'COLUMN-INDEX')} is_required={columnTab === 'index'} />
                        <TextInput action={action} inputName="columnIndex" variables={variables}
                            setOpenVariable={setOpenVariable} disabled={columnTab !== 'index'}
                            isRequired={columnTab === 'index'} fieldType="string-single-column" displayName={t(baseLabel + 'COLUMN-INDEX')} hideRequired />
                        <small className="conf-field-desc"><em>{t(baseLabel + 'COLUMN-INDEX-EG')}</em></small>
                    </RadioOption>

                    <RadioOption value="name" classes={"m-t-20"}>
                        <FieldLabel name={t(excelLabel + 'COLUMN-NAME')} is_required={columnTab === 'name'} />
                        <TextInput action={action} inputName="columnName" variables={variables}
                            setOpenVariable={setOpenVariable} disabled={columnTab !== 'name'}
                            isRequired={columnTab === 'name'} fieldType="string" displayName={t(excelLabel + 'COLUMN-NAME')} hideRequired />
                        <small className="conf-field-desc"><em>{t(baseLabel + 'COLUMN-NAME-EG')}</em></small>
                    </RadioOption>
                </RadioPicker>
            </div> */}
            <div className="conf-field-container">
                <Checkboxes action={action} inputName="sortWithHeader" options={{ label: label + 'SORT-WITH-HEADER' }} />
            </div>
        </div>
    )
}


